/**
 * Created by Arif Topcu in 2019
 */

import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ComplicationSelector from "@ls/grouping-complication-selector";
import FactribSelectorComplication from "./FactribSelectorComplication";
import { selectDefinitions } from "state/factrib/selectors";
import SelectionState from "state/selections/SelectionState";
import { setDefinition as setFactribDefinition } from "state/factrib/actions";
import FactorAttributionDefinition from "state/factrib/FactorAttributionDefinition";

const FactribSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setFactribDefinition(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={FactorAttributionDefinition.getDefault}
      ComplicationComponent={FactribSelectorComplication}
      btnTitle={"Factor Attribution"}
      addMoreText={"Factor Attribution Column"}
    />
  );
};

export default FactribSelector;
